export enum StateEnum {
  USA = 'USA',
  CANADA = 'CANADA',
}
